import type { ErrorRouteComponent } from "@tanstack/react-router";

import { RedirectSpinner } from "@partners/ui";

import { useLogout } from "@/hooks/useLogout";

import { UnauthenticatedHeader } from "../Header";
import { ErrorComponent } from "./ErrorComponent";

export const AUTH_REDIRECT_ERROR_TEXT = "Redirecting to login";
export const AUTH_ERROR_TEXT = "Auth0 error";

export const AuthError: ErrorRouteComponent = ({ error }) => {
  const { logout } = useLogout();
  const message = error instanceof Error ? error.message : undefined;

  return (
    <>
      <UnauthenticatedHeader />
      {message === AUTH_REDIRECT_ERROR_TEXT ? (
        <RedirectSpinner redirectText={message} />
      ) : (
        <ErrorComponent
          error={error}
          errorKey="overviewPage_error"
          onClickReset={
            message === AUTH_ERROR_TEXT
              ? () => logout({ returnTo: "/" })
              : undefined
          }
        />
      )}
    </>
  );
};
